module.exports = __webpack_public_path__ + "56847e95.png";